import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../../core/api';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { createLocation, deleteLocation, editLocation, getLocationsList } from './locations.actions';
import { getFarmsListRequest } from '../farms/farms.actions';

export function* getLocationsListSaga() {
  try {
    const result = yield call(api.locations.getLocations);
    yield put(getLocationsList.done({ result }));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* createLocationSaga(action: ReturnType<typeof createLocation.started>) {
  const { payload } = action;
  try {
    const result = yield call(api.locations.createLocation, payload);
    yield put(createLocation.done({ params: payload, result }));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* editLocationSaga(action: ReturnType<typeof editLocation.started>) {
  const { payload } = action;
  try {
    const { id, ...rest } = payload;
    const result = yield call(api.locations.editLocation, id!, rest);
    yield put(editLocation.done({ params: payload, result }));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* deleteLocationSaga(action: ReturnType<typeof deleteLocation.started>) {
  const { payload } = action;
  try {
    yield call(api.locations.deleteLocation, payload);
    yield put(deleteLocation.done({ params: payload }));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* watchLocationsSaga() {
  yield all([
    yield takeLatest(getLocationsList.started, getLocationsListSaga),
    yield takeLatest(getFarmsListRequest.done, getLocationsListSaga),
    yield takeLatest(createLocation.started, createLocationSaga),
    yield takeLatest(editLocation.started, editLocationSaga),
    yield takeLatest(deleteLocation.started, deleteLocationSaga),
  ]);
}
